import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, RouterOutlet } from '@angular/router';
import { select } from '@angular-redux/store';
import { Observable } from 'rxjs';
import { Auth } from '../../store/auth/auth-state.model';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-svpp-main',
    templateUrl: './svpp-main.component.html',
    styleUrls: ['./svpp-main.component.scss'],
    imports: [NgIf, RouterOutlet]
})
export class SvppMainComponent implements OnInit {
  /**
  * Property to observe the redux auth store
  **/
  @select('auth') readonly authObservable: Observable<Auth>;
  /**
  * Property deletmine is opadmin
  **/
  public isAuthorizedSvpp: boolean;
  constructor(
  ) {
    this.authObservable.subscribe((auth) => {
      this.isAuthorizedSvpp = auth.userAvailableRoles.indexOf('ADMIN') > -1 ||
        auth.userAvailableRoles.indexOf('SUBMITTER') > -1 ||
        auth.userAvailableRoles.indexOf('REVIEWER') > -1 ||
        auth.userAvailableRoles.indexOf('APPROVER') > -1;
    });
  }
  /**
   * @function ngOnInit Method to Initializes the component and perform initial operations
   */
  ngOnInit(): void {
  }

}
